import _ from 'lodash'

const { SHORT_ID_LENGTH, BYOGG_URL } = require('~/constants/byoGG')
const { STATE_TO_ABBR } = require('~/constants/stateToAbbrev')

function byoGG(location) {
  if (!location) return ''
  if (!location.state || !location.city || !location.address) return ''
  if (location.status !== 'OPEN') return ''

  const shortenedState =
    STATE_TO_ABBR[location?.state?.toLowerCase() || ''] || location?.state
  const encodedProject = _.kebabCase(
    location?.brandname || location?.projectname || ''
  )
  const encodedState = _.kebabCase(shortenedState)
  const encodedCity = _.kebabCase(location?.city || '')
  const encodedAddress = _.kebabCase(location?.address?.[0] || '')
  const id = location?.id.slice(-SHORT_ID_LENGTH)

  return `${BYOGG_URL}/${encodedProject}/${id}/${encodedState}/${encodedCity}/${encodedAddress}`
}

function whatsapp(location) {
  if (!location) return ''
  if (!location.whatsapp) return ''
  if (!location.state || !location.city || !location.address) return ''
  if (location.status !== 'OPEN') return ''

  const id = location?.id.slice(-SHORT_ID_LENGTH)
  return `${BYOGG_URL}/w/${id}`
}

const createLinks = {
  byoGG: byoGG,
  whatsapp: whatsapp,
}

export default createLinks
